import { useState } from 'react';
import { useSelector } from 'react-redux';

import { isStaffCheck } from '../../../../selectors/loginSelector';
import { BillingInformationType } from '../../../../types/hubPropTypes';
import { ConnectedEditViewZuora } from './EditViewZuora';
import { ReadView } from './ReadView';

type AccountBillingInformationProps = {
  billingInformation: BillingInformationType;
  error?: boolean;
};

const MIN_HEIGHT = 'min-h-[166px]';

const AccountBillingInformation = ({ billingInformation, error }: AccountBillingInformationProps) => {
  const [mode, setMode] = useState('read');
  const isStaff = useSelector(isStaffCheck);
  let view = null;

  if (error)
    return (
      <div>
        <span className="text-red-4">Error getting billing information</span>
      </div>
    );

  if (mode === 'read') {
    view = (
      <ReadView
        billingInformation={billingInformation}
        setMode={setMode}
        isStaff={isStaff}
        success={billingInformation?.billingInformationSucceedMsg}
      />
    );
  } else if (mode === 'edit') {
    view = <ConnectedEditViewZuora setMode={setMode} zuoraAccountId={billingInformation.zuoraId} />;
  }

  return <section className={`${MIN_HEIGHT} pt-md-8 bg-white pb-6 pt-5`}>{view}</section>;
};

export default AccountBillingInformation;
